import React, { useState, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const BarcodePrinter = () => {
    const [Product_ID, setProduct_ID] = useState(''); // Product_ID input
    const [sku, setSku] = useState(''); // Retrieved SKU
    const canvasRef = useRef(null); // Ref for barcode canvas
    const brandName = "TJD - DharmApanah"; // Brand Name

    // Fetch SKU from backend based on Product_ID
    const fetchSKU = async () => {
        if (!Product_ID) return;
        try {
            const response = await fetch(`https://st.tjdstore.in/api/getsku.php?Product_ID=${Product_ID}`);
            const data = await response.json();
            if (data.sku) {
                setSku(data.sku);
            } else {
                alert('SKU not found for the given Product_ID.');
            }
        } catch (error) {
            console.error('Error fetching SKU:', error);
            alert('Failed to fetch SKU.');
        }
    };

    // Generate Barcode
    const generateBarcode = () => {
        if (canvasRef.current && Product_ID) {
            JsBarcode(canvasRef.current, Product_ID, {
                format: 'CODE128',
                displayValue: false,
                fontSize: 16, // Adjust font size for SKU display
                width: 1.5, // Width of barcode bars
                height: 26, // Height of barcode
                margin: 0, // Remove default margin
            });
        }
    };

    // Print the label
    const printBarcode = () => {
        const newWindow = window.open('', '_blank'); // Open a new window for print
        const barcodeImage = canvasRef.current.toDataURL(); // Convert canvas to image
        const htmlContent = `
            <html>
                <head>
                    <style>
                        body {
                            margin: 0;
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100%;
                        }
                        .label {
                            width: 50mm;
                            height: 18mm;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            border: 1px solid #000;
                            overflow: hidden;
                            margin-top: 14px;
                             padding: 0;
                        box-sizing: border-box;
                        }
                        .brand-name {
                            font-size: 10px;
                            font-weight: bold;
                            margin-bottom: 3px;
                            font-family: Verdana, Arial, Helvetica, sans-serif;
                        }
                       
                        .sku-text {
                            font-size: 10px;
                            margin-top: 3px;
                            font-family: Verdana, Arial, Helvetica, sans-serif;
                        }
                    </style>
                </head>
                <body>
                    <div class="label">
                        <div class="brand-name">${brandName}</div>
                        <img src="${barcodeImage}" alt="Barcode" />
                        <div class="sku-text">SKU: ${sku}</div>
                    </div>
                    <script>
                        window.onload = function() {
                            window.print();
                            window.close();
                        };
                    </script>
                </body>
            </html>
        `;
        newWindow.document.write(htmlContent);
        newWindow.document.close();
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>SKU Barcode Label Printer</h2>
            <div style={{ marginBottom: '10px' }}>
                <label htmlFor="Product_ID">Enter Product ID:</label>
                <input
                    id="Product_ID"
                    type="text"
                    value={Product_ID}
                    onChange={(e) => setProduct_ID(e.target.value)} // Update Product_ID
                    placeholder="Type Product ID here"
                    style={{ marginLeft: '10px', padding: '5px' }}
                />
                <button
                    onClick={fetchSKU}
                    disabled={!Product_ID}
                    style={{ marginLeft: '10px', padding: '5px 10px', backgroundColor: 'orange', color: 'white', border: 'none' }}
                >
                    Fetch SKU
                </button>
            </div>
            {sku && (
                <div>
                    <canvas ref={canvasRef} style={{ border: '1px solid #000' }}></canvas>
                    <br />
                    <button
                        onClick={generateBarcode}
                        style={{ padding: '5px 10px', backgroundColor: 'blue', color: 'white', border: 'none', marginRight: '10px' }}
                    >
                        Generate Barcode
                    </button>
                    <button
                        onClick={printBarcode}
                        style={{ padding: '5px 10px', backgroundColor: 'green', color: 'white', border: 'none' }}
                    >
                        Print Label
                    </button>
                </div>
            )}
        </div>
    );
};

export default BarcodePrinter;
